import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import { D1, GradientSpan, H1, P3 } from "../../components/theme/text/Headings";

import {
  Blue,
  White,
  NeonGreen,
  OffWhite,
  gradientColors,
} from "../../components/theme/colors";
import { ButtonGradient } from "../../components/theme/Button";
import { useAuth } from "../../services/AuthContext";
import { auth, db } from "../../services/firebase.config";
import { doc, getDoc } from "firebase/firestore";
import LayoutOnboarding from "../../components/layout/layoutOnboarding";

const TopContent = styled.div`
  margin-top: 6vh;
  padding: 0 15px;
`;

const BottomLogin = styled.div`
  position: absolute;
  bottom: 100px;
  left: 2vh;
  right: 2vh;
`;

const AgeRestriction = () => {
  const navigate = useNavigate();
  const { currentUserState } = useAuth();
  const [userAge, setUserAge] = useState(null);

  useEffect(() => {
    const fetchUserAge = async () => {
      if (!currentUserState) return;

      try {
        const profileDocRef = doc(db, "public-profiles", currentUserState.uid);
        const profileDoc = await getDoc(profileDocRef);

        if (profileDoc.exists()) {
          const data = profileDoc.data();
          if (data.birthday) {
            const birthDate = data.birthday.toDate
              ? data.birthday.toDate()
              : new Date(data.birthday);
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();

            if (
              monthDiff < 0 ||
              (monthDiff === 0 && today.getDate() < birthDate.getDate())
            ) {
              age--;
            }

            setUserAge(age);
          }
        }
      } catch (error) {
        // Silently fail - age data is optional
      }
    };

    fetchUserAge();
  }, [currentUserState]);

  const handleSignOut = async () => {
    try {
      await auth.signOut();
      navigate("/login");
    } catch (error) {
      // Silently fail - logout errors don't prevent navigation
    }
  };

  return (
    <LayoutOnboarding>
      <Container>
        <Row>
          <Col
            lg={{ offset: 4, span: 4 }}
            md={{ offset: 3, span: 6 }}
            sm={{ offset: 2, span: 8 }}
            xs={{ span: 12 }}
            className="text-align-center"
          >
            <TopContent>
              <D1 color={White}>
                Age <br />
                <GradientSpan
                  $background={NeonGreen}
                  $transitionBackground={Blue}
                >
                  Restriction
                </GradientSpan>
              </D1>
              <H1 color={White} className="mt-40 mb-40">
                Sorry, you must be at least 17 years old to use Vibe Check.
              </H1>
              {userAge && (
                <P3 color={OffWhite} className="mb-20">
                  You are currently {userAge} years old.
                </P3>
              )}
              <P3 color={OffWhite} className="mb-40">
                This app is designed for users 17 and older. Please come back
                when you're older!
              </P3>
            </TopContent>
            <BottomLogin>
              <div style={{ padding: "0 15px" }}>
                <ButtonGradient
                  width="100%"
                  className="mt-20"
                  $background={gradientColors["personality-check"].background}
                  $transitionBackground={
                    gradientColors["personality-check"].transitionBackground
                  }
                  onClick={handleSignOut}
                >
                  Sign Out
                </ButtonGradient>
              </div>
            </BottomLogin>
          </Col>
        </Row>
      </Container>
    </LayoutOnboarding>
  );
};

export default AgeRestriction;
